import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { handleRequestError, handleRequestSuccess } from "utils/Request";
import { InstabilityAlertSettings } from "hooks/fetch/useInstabilityAlert";

async function updateInstabilityAlert(data: InstabilityAlertSettings) {
  const response = await api.put('/instability-alert', data);
  return response.data;
}

export function useUpdateInstabilityAlert() {
  const queryClient = useQueryClient();

  return useMutation((data: InstabilityAlertSettings) => updateInstabilityAlert(data), {
    onSuccess: () => {
      handleRequestSuccess('Alerta de instabilidade atualizado com sucesso!');
      queryClient.invalidateQueries('instability-alert');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao salvar alerta de instabilidade. Tente novamente.');
    },
  });
}
